import { render, staticRenderFns } from "./TableClusterUnused.vue?vue&type=template&id=ca7a49ae&scoped=true&"
import script from "./TableClusterUnused.vue?vue&type=script&lang=js&"
export * from "./TableClusterUnused.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7a49ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VDataTable,VHover})
